'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var subtleShadow = exports.subtleShadow = {
    boxShadow: '0 2px 0 0 rgba(0, 0, 0, 0.05)'
};
//# sourceMappingURL=effects.js.map